import React from 'react';

class CountUpText extends React.Component {
  constructor(props) {
    super(props);
    this.state = { value: props.start || 0 };
    this._raf = null;
  }
  componentDidMount() {
    this.animate(this.props.start || 0, this.props.end || 0, this.props.duration || 800);
  }
  componentDidUpdate(prev) {
    if (prev.end !== this.props.end) {
      cancelAnimationFrame(this._raf || 0);
      this.animate(this.state.value, this.props.end || 0, this.props.duration || 800);
    }
  }
  componentWillUnmount() {
    if (this._raf) cancelAnimationFrame(this._raf);
  }
  animate = (start, end, duration) => {
    const startTs = performance.now();
    const delta = (end || 0) - (start || 0);
    const step = (ts) => {
      const p = Math.min(1, (ts - startTs) / duration);
      this.setState({ value: start + delta * p });
      if (p < 1) this._raf = requestAnimationFrame(step);
    };
    this._raf = requestAnimationFrame(step);
  };
  render() {
    const { formatter = (v) => Math.round(v).toLocaleString() } = this.props;
    return <>{formatter(this.state.value)}</>;
  }
}

export default CountUpText;


